// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// 👇 Paste your actual config below:
const firebaseConfig = {
  apiKey: "AIzaSyCliQo_5CmJ96v5Gsl_U-etcvMaUbnB9Hg",
  authDomain: "theyda-app.firebaseapp.com",
  projectId: "theyda-app",
  storageBucket: "theyda-app.firebasestorage.app",
  messagingSenderId: "1038145481463",
  appId: "1:1038145481463:web:c1afeb498715ceff9541f2",
  measurementId: "G-QR3X9PJ4ED"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

